<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'app#city_card#pos_list#title' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="goToMap()">
        <ion-icon slot="icon-only" name="map-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <ion-toolbar>
    <ion-searchbar
      [placeholder]="'app#city_card#pos_list#search_placeholder' | translate"
      (ionInput)="onSearch($event)"
      debounce="0"
    ></ion-searchbar>
  </ion-toolbar>

  <ion-toolbar>
    <ion-segment [value]="sortMode()" (ionChange)="setSortMode($event)">
      <ion-segment-button value="distance">
        <ion-label>{{ 'app#city_card#pos_list#sort_distance' | translate }}</ion-label>
      </ion-segment-button>
      <ion-segment-button value="alphabet">
        <ion-label>{{ 'app#city_card#pos_list#sort_alphabet' | translate }}</ion-label>
      </ion-segment-button>
    </ion-segment>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-refresher slot="fixed" (ionRefresh)="doRefresh($event)">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>

  @if (isLoading() && sortedItems().length === 0) {
    <div class="loading-state">
      <ion-spinner name="crescent"></ion-spinner>
    </div>
  } @else if (sortedItems().length === 0) {
    <div class="empty-state">
      <ion-icon name="storefront-outline"></ion-icon>
      <p>{{ 'app#city_card#pos_list#empty' | translate }}</p>
    </div>
  } @else {
    <ion-list lines="full">
      @for (item of sortedItems(); track item.id) {
        <ion-item button detail (click)="goToDetail(item)">
          <ion-avatar slot="start">
            @if (item.photos?.[0]?.url) {
              <ion-img [src]="item.photos![0].url"></ion-img>
            } @else {
              <div class="avatar-placeholder">
                <ion-icon name="storefront-outline"></ion-icon>
              </div>
            }
          </ion-avatar>

          <ion-label>
            <h2>{{ item.title }}</h2>
            @if (item.addresses) {
              <p>{{ item.addresses }}</p>
            }
          </ion-label>

          @if (getDistance(item); as dist) {
            <ion-note slot="end" class="distance">
              {{ dist < 1 ? (dist * 1000 | number:'1.0-0') + ' м' : (dist | number:'1.1-1') + ' км' }}
            </ion-note>
          }
        </ion-item>
      }
    </ion-list>

    <ion-infinite-scroll [disabled]="!hasMore()" (ionInfinite)="loadMore($event)">
      <ion-infinite-scroll-content></ion-infinite-scroll-content>
    </ion-infinite-scroll>
  }
</ion-content>
